export default "__VITE_ASSET__DzcITn6b__"